import { useUserImageStore } from "../../store/user-image.store.js";

const DJB2_INITIAL_HASH = 5381;
const DJB2_MULTIPLIER = 33;
const DJB2_BITS = 32;
const DJB2_MOD = 2 ** DJB2_BITS;

/**
 * DJB2 string hash — produces a compact numeric signature for
 * deduplication without storing the full serialized payload.
 */
export const simpleStringHash = (input: string): number => {
  let hash = DJB2_INITIAL_HASH;
  for (let i = 0; i < input.length; i += 1) {
    hash = (hash * DJB2_MULTIPLIER + input.charCodeAt(i)) % DJB2_MOD;
  }
  return hash;
};

const DESKTOP_BRIDGE_DEVICE_ID_STORAGE_KEY = "bezoned.desktop-bridge.device-id";
const DEVICE_ID_RANDOM_RADIX = 16;
const DEVICE_ID_PREFIX = "device";

const createFallbackDeviceId = (): string =>
  `${DEVICE_ID_PREFIX}-${Date.now()}-${Math.random().toString(DEVICE_ID_RANDOM_RADIX).slice(2)}`;

export const getOrCreateDesktopBridgeDeviceId = (): string => {
  try {
    const existingValue = window.localStorage.getItem(
      DESKTOP_BRIDGE_DEVICE_ID_STORAGE_KEY
    );

    if (existingValue && existingValue.length > 0) {
      return existingValue;
    }

    const nextValue =
      typeof globalThis.crypto?.randomUUID === "function"
        ? globalThis.crypto.randomUUID()
        : createFallbackDeviceId();

    window.localStorage.setItem(
      DESKTOP_BRIDGE_DEVICE_ID_STORAGE_KEY,
      nextValue
    );
    return nextValue;
  } catch {
    return createFallbackDeviceId();
  }
};

export const getCurrentUserPictureUrl = (userId: string): string | null =>
  useUserImageStore.getState().getPhoto(userId);
